import { useMemo } from "react"
import { useTheme } from "@mui/material"

import type { TFunction } from "i18next"

import type { SingleStatConfig } from "types/singleStatPlot.types"
import type { SingleStatPlotView, RecordType } from "types/dashboard.types"

import singleStatConfig from "./singleStat"

interface UseSingleStatConfig {
  view: SingleStatPlotView
  data: RecordType[]
  locale?: string
  t: TFunction
}

export default function useSingleStatConfig({
  view,
  data,
  locale,
  t,
}: UseSingleStatConfig) {
  const theme = useTheme()

  const graphConfig: SingleStatConfig = useMemo(
    () =>
      singleStatConfig({
        view,
        data,
        palette: theme.palette,
        locale,
        t,
      }),
    [data, view, locale, theme.palette, t],
  )

  return graphConfig
}
